import { CalendarViewEnum } from '../constants/calendar.constant';

export const formatDateToStr = (date: Date): string => {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${month}/${day}/${year}`;
};

export const generateLastSixMonthsLabels = () => {
  let labels = [];
  let date = new Date();

  for (let i = 0; i < 6; i++) {
    let month = date.getMonth() + 1; // getMonth() is zero-based
    let year = date.getFullYear();

    // zero-pad the month and format the string
    let label = `${month < 10 ? '0' : ''}${month}-01-${year}`;
    labels.unshift(label); // add to the front of the array

    // go to previous month
    date.setMonth(date.getMonth() - 1);
  }

  return labels;
};

export const getStartOfWeek = (date: Date): Date => {
  const day = date.getDay();
  const difference = date.getDate() - day;
  return new Date(date.getFullYear(), date.getMonth(), difference);
};

export const calculateNewCalendarView = (
  action: 'Next' | 'Prev',
  view: CalendarViewEnum,
  currentMonth: number,
  currentYear: number,
  currentStartOfWeek: Date
) => {
  let updatedDate = currentStartOfWeek;
  let updatedMonth = currentMonth;
  let updatedYear = currentYear;
  let updatedStartOfWeek = currentStartOfWeek;

  switch (view) {
    case CalendarViewEnum.Day:
      break;
    case CalendarViewEnum.Month:
      ({ updatedMonth, updatedYear } =
        action === 'Next'
          ? getNextMonth(currentMonth, currentYear)
          : getPrevMonth(currentMonth, currentYear));
      updatedDate = getFirstSundayOfMonth(updatedMonth, updatedYear);
      updatedStartOfWeek = getFirstSundayOfMonth(updatedMonth, updatedYear);
      break;
    case CalendarViewEnum.Week:
      updatedStartOfWeek = new Date(currentStartOfWeek);
      action === 'Next'
        ? updatedStartOfWeek.setDate(updatedStartOfWeek.getDate() + 7)
        : updatedStartOfWeek.setDate(updatedStartOfWeek.getDate() - 7);
      updatedDate = new Date(updatedStartOfWeek);
      updatedMonth = updatedStartOfWeek.getMonth();
      updatedYear = updatedStartOfWeek.getFullYear();
      break;
    case CalendarViewEnum.Year:
      break;
    default:
      break;
  }

  return { updatedDate, updatedStartOfWeek, updatedMonth, updatedYear };
};

export const getNextMonth = (
  currentMonth: number,
  currentYear: number
): { updatedMonth: number; updatedYear: number } => {
  if (currentMonth === 11) {
    return { updatedMonth: 0, updatedYear: currentYear + 1 };
  }
  return { updatedMonth: currentMonth + 1, updatedYear: currentYear };
};

export const getPrevMonth = (
  currentMonth: number,
  currentYear: number
): { updatedMonth: number; updatedYear: number } => {
  if (currentMonth === 0) {
    return { updatedMonth: 11, updatedYear: currentYear - 1 };
  }
  return { updatedMonth: currentMonth - 1, updatedYear: currentYear };
};

export const getFirstSundayOfMonth = (month: number, year: number) => {
  const firstDay = new Date(year, month, 1);

  const daysToNextSunday = (7 - firstDay.getDay()) % 7;
  firstDay.setDate(firstDay.getDate() + daysToNextSunday);

  return firstDay;
};

export const formatTime = (date: Date) => {
  let hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';

  hours = hours % 12;
  const hoursStr = hours ? hours + '' : '12'; // the hour '0' should be '12'
  const minutesStr = minutes < 10 ? '0' + minutes : minutes;

  return hoursStr + ': ' + minutesStr + ' ' + ampm;
};

export const isSameDate = (date1: Date, date2: Date) => {
  return (
    date1.getDate() === date2.getDate() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getFullYear() === date2.getFullYear()
  );
};
